



























import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

export default {
  name: 'ResultTestModalBody',
  components: { AppButtonNew },
  props: {
    result: {
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/resultTestModalBody/ResultTestModalBody.vue